import { useMutation, useQuery } from "@tanstack/react-query";
import { subjectCheckoutService } from "./subjectcheckout.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useSubjectCheckout = ({
  searchText,
  pageNumber,
  pageSize,
  subjectCheckoutId,
  periodId,
  studyId,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  subjectCheckoutId?: number | null;
  periodId?: string | null;
  studyId?: number | string | null;
} = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: [
      "subjectcheckout-selectAll",
      { searchText, pageNumber, pageSize, periodId, studyId },
    ],
    queryFn: () =>
      subjectCheckoutService.getSelectAllData({
        searchtext: (searchText ?? "").trim(),
        currentpage: pageNumber ?? 1,
        pagesize: pageSize ?? 10,
        status: "A",
        periodid: periodId ?? null,
        studyid: studyId ?? null,
      }),
    enabled: !!pageNumber && !!pageSize && !!periodId,
  });

  const SelectQuery = useQuery({
    queryKey: ["subjectcheckout-select", { subjectCheckoutId }],
    queryFn: () =>
      subjectCheckoutService.getSelectData({
        subjectcheckoutid: subjectCheckoutId!,
        status: "A",
      }),
    enabled: !!subjectCheckoutId,
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload) => subjectCheckoutService.updateData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload) => subjectCheckoutService.deleteData(payload),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    UpdateMutation,
    DeleteMutation,
  };
};
